import React, {useState} from 'react';
import {Select, Button, Space} from 'antd';
import {PlusOutlined} from "@ant-design/icons";
import {getRoleLabel} from "../../utils/labelHelper";

const SYSTEM_ROLES = ['default-roles-amj-global', 'offline_access', 'uma_authorization'];

const AssignRole = ({availableRoles, onAssign, isUpdating}) => {
    const [selectedRole, setSelectedRole] = useState(null);

    const filteredRoles = availableRoles.filter((role) => !SYSTEM_ROLES.includes(role.name));

    const handleAssign = () => {
        if (selectedRole) {
            onAssign(selectedRole);
            setSelectedRole(null);
        }
    };

    return (
        <Space.Compact style={{width: '100%'}}>
            <Select
                style={{width: '100%'}}
                placeholder="Select a role to assign"
                value={selectedRole}
                onChange={setSelectedRole}
                disabled={isUpdating}
                optionLabelProp="label"
            >
                {filteredRoles.map((role) => (
                    <Select.Option key={role.name} value={role.name} label={getRoleLabel(role)}>
                        <div>
                            <div style={{fontWeight: 500}}>{getRoleLabel(role)}</div>
                            <div style={{fontSize: 12, color: '#888'}}>
                                {role.name}
                            </div>
                        </div>
                    </Select.Option>
                ))}
            </Select>
            <Button
                type="primary"
                icon={<PlusOutlined/>}
                onClick={handleAssign}
                disabled={!selectedRole}
                loading={isUpdating}
            >
                Assign
            </Button>
        </Space.Compact>
    );
};

export default AssignRole;
